import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { returnRefundByDay: { getReturnRefundByDay } } = apiUrls;

export const RETURN_REFUND_BY_DAY_SUCCESS = 'RETURN_REFUND_BY_DAY_SUCCESS';
export const RETURN_REFUND_BY_DAY_LOADING = 'RETURN_REFUND_BY_DAY_LOADING';

export const getReturnRefundByDayData = ({ from, to, type }) => async (dispatch) => {
    try {
        const requestData = {
            ...getReturnRefundByDay,
            url: getReturnRefundByDay.url.replace('{from}', from).replace('{to}', to).replace('{type}', type)
        };
        const data = await REQUEST(requestData);
        dispatch({
            type: RETURN_REFUND_BY_DAY_SUCCESS,
            data,                
        })

    } catch (e) {
        dispatch({
            type: RETURN_REFUND_BY_DAY_SUCCESS,
            data: {
                code: "",
                modal: null,
                notifications: null,
                paginationInfo: null
            },            
        })
    }

}

export const handleLoader = isLoading => (dispatch) => {
    dispatch({
        type: RETURN_REFUND_BY_DAY_LOADING,
        isLoading,
    });
}